import { AlignType, MarginType } from 'common/types/styleTypes'
import {
  marginCss,
  mobileMarginCss,
  mobileTextCss,
  textCss,
} from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

type BlogPostCategoriesNewUiProps = {
  fontSize: number
  color: string
  fontFamily?: string
  fontWeight?: string
  fontStyle?: string
  textAlign: AlignType
  mobileColor?: string
  mobileFontSize?: number
  mobileFontFamily?: string
  mobileFontWeight?: string
  mobileFontStyle?: string
  mobileTextAlign?: AlignType
  mobileFontFilePath?: string
  margin?: Partial<MarginType>
  mobileMargin?: Partial<MarginType>
}

const BlogPostCategoriesNewUi = styled.div<BlogPostCategoriesNewUiProps>`
  ${textCss};
  ${marginCss}
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`

export default BlogPostCategoriesNewUi
